<script setup>

import {computed} from "vue";

const emit = defineEmits(['click']);
const props = defineProps({
  dir: String
})
    const className = computed(() => {
      var classString = 'nav-button';
      classString = props.dir === '<' ? classString + ' prev' : classString;
      classString = props.dir === '>' ? classString + ' next' : classString;
      classString = props.dir === '<<' ? classString + ' restart' : classString;
      return classString
    })
    const direction = computed(() => {
      var directionString = '';
      directionString = props.dir === '<' ? 'Previous: ' : directionString;
      directionString = props.dir === '>' ? 'Next: ' : directionString;
      directionString = props.dir === '<<' ? 'Start again' : directionString;
      return directionString
    })
</script>

<template>
    <button v-on:click="emit('click')" v-bind:class="className">
        <span class="nb__arrow"></span>
        <span class="nb__text">
            <b v-if="direction.length">{{ direction }}</b>
            <slot></slot>
        </span>
    </button>
</template>
